(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["labdip-river-funnel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('labdip-river-funnel')) {
  customElements.define('labdip-river-funnel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.lifecycle = new AbortController();
      this.config = JSON.parse(this.querySelector('[data-river-config]').dataset.config);
      this.products = this.config.products;
      this.product = this.products[0] || null;
      this.variant = null;
      this.cart = null;
      this.busy = false;
      this.currentStep = 'discover';
      this.testMode = this.dataset.mode !== 'live';
      this.money = new Intl.NumberFormat(this.config.locale || 'fr', { style: 'currency', currency: this.config.currency });
      const options = { signal: this.lifecycle.signal };
      this.addEventListener('click', event => this.onClick(event), options);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-product-choice]')) this.chooseProduct(event.target.value);
      }, options);
      this.querySelector('[data-fit-form]').addEventListener('submit', event => {
        event.preventDefault();
        const choices = Array.from(event.target.querySelectorAll('input:checked')).map(input => input.value);
        const match = choices.includes('wide') && choices.includes('hips');
        this.querySelector('[data-fit-title]').textContent = this.config.text[match ? 'fitYes' : 'fitNo'];
        this.querySelector('[data-fit-copy]').textContent = this.config.text[match ? 'fitYesCopy' : 'fitNoCopy'];
        event.target.hidden = true;
        this.querySelector('[data-fit-result]').hidden = false;
      }, options);
      window.addEventListener('popstate', event => {
        const state = event.state && event.state.river;
        if (state && state.id === this.id) this.navigate(state.step, false);
        else this.navigate('discover', false);
      }, options);
      this.querySelector('[data-dialog=guide]').addEventListener('close', () => this.cancelKiwi(), options);
      this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('click', event => {
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }
      }, options));
      this.chooseProduct(this.product && this.product.key);
      this.dataset.step = 'discover';
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.cancelKiwi();
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      this.initialized = false;
    }
    setError(message) {
      const target = this.querySelector('[data-error]');
      target.textContent = message;
      if (message) { target.focus({ preventScroll: true }); target.scrollIntoView({ block: 'center', behavior: 'auto' }); }
    }
    navigate(step, push = true) {
      if (!['discover', 'fit', 'product', 'cart', 'boundary'].includes(step)) return;
      if (step === 'product' && !this.product) { this.setError(this.config.text.setup); return; }
      if ((step === 'cart' || step === 'boundary') && !this.cart) { this.setError(this.config.text.empty); return; }
      this.setError('');
      this.querySelectorAll('video').forEach(video => video.pause());
      this.currentStep = step;
      this.dataset.step = step;
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== step; });
      this.querySelectorAll('.river-steps [data-go]').forEach(button => {
        if (button.dataset.go === step || (step === 'boundary' && button.dataset.go === 'cart')) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
      if (push) window.history.pushState({ ...window.history.state, river: { id: this.id, step } }, '', `#${this.id}-${step}`);
      this.scrollIntoView({ block: 'start', behavior: 'auto' });
      this.querySelector(`[data-panel="${step}"] h1, [data-panel="${step}"] h2`)?.focus({ preventScroll: true });
    }
    chooseProduct(key) {
      this.cancelKiwi();
      this.product = this.products.find(product => product.key === key) || null;
      this.variant = null;
      this.querySelector('[data-selection]').textContent = this.config.text.select;
      this.querySelectorAll('[data-product-choice]').forEach(input => { input.checked = !!this.product && input.value === this.product.key; });
      const holder = this.querySelector('[data-variants]');
      holder.replaceChildren();
      if (!this.product) return;
      this.querySelector('[data-product-title]').textContent = this.product.title;
      this.querySelectorAll('[data-product-url]').forEach(link => { link.href = this.product.url; });
      this.querySelectorAll('[data-price]').forEach(target => { target.textContent = this.product.priceText; });
      this.showImage(this.querySelector('[data-product-image]'), this.product.image, this.product.title);
      if (this.product.variantCount > 250 || this.product.requiresSellingPlan) {
        holder.textContent = this.config.text[this.product.requiresSellingPlan ? 'subscription' : 'variantLimit'];
        return;
      }
      this.product.variants.forEach(variant => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.variant = String(variant.id);
        button.textContent = variant.title;
        button.disabled = !variant.available;
        button.setAttribute('aria-pressed', 'false');
        if (!variant.available) button.setAttribute('aria-label', `${variant.title} — ${this.config.text.unavailable}`);
        holder.append(button);
      });
    }
    cancelKiwi() {
      this.kiwiSequence = (this.kiwiSequence || 0) + 1;
      window.clearTimeout(this.kiwiPoll);
      window.clearTimeout(this.kiwiTimeout);
      this.querySelector('[data-kiwi-content]')?.replaceChildren();
    }
    openGuide() {
      if (!this.product) { this.setError(this.config.text.setup); return; }
      this.cancelKiwi();
      const sequence = this.kiwiSequence;
      const product = this.product;
      const dialog = this.querySelector('[data-dialog=guide]');
      const status = this.querySelector('[data-kiwi-status]');
      const fallback = this.querySelector('[data-kiwi-fallback]');
      const holder = document.createElement('div');
      holder.className = 'river-kiwi-target';
      this.querySelector('[data-kiwi-content]').append(holder);
      status.textContent = this.config.text.kiwiLoading;
      fallback.hidden = true;
      dialog.showModal();
      const current = () => this.isConnected && sequence === this.kiwiSequence && this.product?.key === product.key;
      const finished = success => {
        if (!current()) return;
        window.clearTimeout(this.kiwiPoll);
        window.clearTimeout(this.kiwiTimeout);
        status.textContent = '';
        fallback.hidden = !!success;
        if (!success) { holder.remove(); this.kiwiSequence += 1; }
      };
      this.kiwiTimeout = window.setTimeout(() => finished(false), 12000);
      const attempt = () => {
        if (!current()) return;
        if (typeof window.ks?.loadSizing !== 'function') {
          this.kiwiPoll = window.setTimeout(attempt, 150);
          return;
        }
        try {
          window.ks.loadSizing({
            productData: product.kiwi,
            options: { el: holder, displayMode: 0, calculatorDisplayMode: 0, layoutType: 2 },
            loaded: success => finished(!!success)
          });
        } catch { finished(false); }
      };
      attempt();
    }
    showImage(image, url, alt) {
      image.hidden = !url;
      if (url) image.src = url;
      else image.removeAttribute('src');
      image.alt = alt;
    }
    selectVariant(id) {
      const variant = this.product?.variants.find(item => String(item.id) === String(id));
      if (!variant || !variant.available) return;
      this.variant = variant;
      this.setError('');
      this.querySelectorAll('[data-variant]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.variant === String(id))));
      this.querySelector('[data-selection]').textContent = `${this.product.title} · ${variant.title}`;
      this.querySelectorAll('[data-price]').forEach(target => { target.textContent = variant.priceText; });
      this.showImage(this.querySelector('[data-product-image]'), variant.image || this.product.image, `${this.product.title} · ${variant.title}`);
    }
    async addItem() {
      if (this.busy) return;
      if (!this.variant || !this.variant.available) { this.setError(this.config.text.select); return; }
      const input = this.querySelector('[data-quantity]');
      if (!input.checkValidity()) { input.reportValidity(); return; }
      const quantity = Number(input.value);
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 5) return;
      const product = this.product;
      const variant = this.variant;
      if (!this.testMode) {
        this.busy = true;
        this.querySelectorAll('[data-add]').forEach(button => { button.disabled = true; button.textContent = this.config.text.adding; });
        this.querySelectorAll('[data-product-choice], [data-variant], [data-quantity]').forEach(control => { control.disabled = true; });
        try {
          const root = window.Shopify?.routes?.root || this.config.rootUrl;
          const response = await fetch(`${root.endsWith('/') ? root : root + '/'}cart/add.js`, {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity }] })
          });
          const result = await response.json();
          if (!response.ok) { this.setError(result.description || result.message || this.config.text.addError); return; }
        } catch { this.setError(this.config.text.addError); return; }
        finally {
          this.busy = false;
          this.querySelectorAll('[data-add]').forEach(button => { button.disabled = false; button.textContent = this.config.text.add; });
          this.querySelectorAll('[data-product-choice], [data-quantity]').forEach(control => { control.disabled = false; });
          this.querySelectorAll('[data-variant]').forEach(button => { button.disabled = !product.variants.find(item => String(item.id) === button.dataset.variant)?.available; });
        }
      }
      this.cart = { product, variant, quantity };
      this.querySelector('.river-steps [data-go=cart]').disabled = false;
      this.querySelector('[data-cart-title]').textContent = product.title;
      this.querySelector('[data-cart-variant]').textContent = variant.title;
      this.querySelector('[data-cart-quantity]').textContent = `${this.config.text.quantity} : ${quantity}`;
      this.querySelector('[data-cart-subtotal]').textContent = this.money.format(variant.price * quantity / 100);
      this.showImage(this.querySelector('[data-cart-image]'), variant.image || product.image, product.title);
      if (!this.testMode) this.querySelector('[data-next]').textContent = this.config.text.shopifyCart;
      this.navigate('cart');
    }
    onClick(event) {
      const target = event.target.closest('button, [data-go-reviews]');
      if (!target || !this.contains(target) || target.disabled) return;
      if (target.dataset.go) this.navigate(target.dataset.go);
      if (target.dataset.open === 'guide') this.openGuide();
      else if (target.dataset.open) this.querySelector(`[data-dialog="${target.dataset.open}"]`).showModal();
      if (target.hasAttribute('data-close')) target.closest('dialog').close();
      if (target.dataset.variant) this.selectVariant(target.dataset.variant);
      if (target.hasAttribute('data-add')) this.addItem();
      if (target.hasAttribute('data-next')) {
        if (this.testMode) this.navigate('boundary');
        else window.location.assign(this.config.cartUrl);
      }
      if (target.hasAttribute('data-fit-reset')) {
        this.querySelector('[data-fit-form]').hidden = false;
        this.querySelector('[data-fit-result]').hidden = true;
      }
      if (target.hasAttribute('data-go-reviews')) { this.navigate('discover'); this.querySelector('.river-review-band').scrollIntoView({ block: 'start', behavior: 'auto' }); }
      if (target.hasAttribute('data-restart')) {
        this.cart = null;
        this.querySelector('.river-steps [data-go=cart]').disabled = true;
        this.querySelector('[data-fit-form]').reset();
        this.querySelector('[data-fit-form]').hidden = false;
        this.querySelector('[data-fit-result]').hidden = true;
        this.querySelector('[data-quantity]').value = '1';
        this.chooseProduct(this.products[0]?.key);
        this.navigate('discover');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === "true") {
        return;
      }

      this.dataset.initialized = "true";
      this.loadRecommendations();
    }

    async loadRecommendations() {
      const sectionWrapper = this.closest(
        "[data-product-recommendations-section]"
      );

      try {
        const response = await fetch(this.dataset.url);

        if (!response.ok) {
          throw new Error(
            `Erreur lors du chargement des recommandations : ${response.status}`
          );
        }

        const responseText = await response.text();
        const temporaryContainer = document.createElement("div");

        temporaryContainer.innerHTML = responseText;

        const recommendationsElement =
          temporaryContainer.querySelector("product-recommendations");

        const recommendationCards =
          recommendationsElement?.querySelectorAll(".grid__item");

        const hasRecommendations =
          recommendationCards && recommendationCards.length > 0;

        if (!hasRecommendations) {
          sectionWrapper?.remove();
          return;
        }

        this.innerHTML = recommendationsElement.innerHTML;
        this.classList.add("product-recommendations--loaded");

        if (sectionWrapper) {
          sectionWrapper.hidden = false;
        }
      } catch (error) {
        console.error(
          "Impossible de charger les recommandations produit.",
          error
        );

        sectionWrapper?.remove();
      }
    }
  }

  if (!customElements.get("product-recommendations")) {
    customElements.define(
      "product-recommendations",
      ProductRecommendations
    );
  }

  } catch(e) { console.error(e); }
})();
})();
